import React from "react";
import "./ImageComponent.css";

function ImageComponent({ src, alt }) {
  return (
    <div className="media-container">
      <img src={src} alt={alt || "Image"} />
    </div>
  );
}

export default ImageComponent;
